export default class Utilidades {
    static loadEstados(pais) {
        return axios.get("/utilidades/estados/" + pais)
            .then(function (response) {
                let ufs = response.data.data;
                jQuery("#formEstado").html("");
                jQuery("#formEstado").append('<option value="" disabled="disabled" selected="selected">Selecione uma Opção</option>');
                for (let i in ufs) {
                    jQuery("#formEstado").append('<option value="' + ufs[i].sigla + '">' + ufs[i].nome + '</option>');
                }
            })
            .catch(function (response) {
                alert(response.message);
            });
    }

    static loadCidades(estado) {
        return axios.get("/utilidades/cidades/" + estado)
            .then(function (response) {
                let mun = response.data.data;
                jQuery("#formMunicipio").html("");
                jQuery("#formMunicipio").append('<option value="" disabled="disabled" selected="selected">Selecione uma Opção</option>');
                for (let i in mun) {
                    jQuery("#formMunicipio").append('<option value="' + mun[i].ibge + '">' + mun[i].nome + '</option>');
                }
            })
            .catch(function (response) {
                alert(response.message);
            });
    }

    static loadBairros(cidade) {
        return axios.get("/utilidades/bairros/" + cidade)
            .then(function (response) {
                let bai = response.data.data;
                jQuery("#formBairro").html("");
                jQuery("#formBairro").append('<option value="" disabled="disabled" selected="selected">Selecione uma Opção</option>');
                for (let i in bai) {
                    jQuery("#formBairro").append('<option value="' + bai[i].ibge + '">' + bai[i].nome + '</option>');
                }
            })
            .catch(function (response) {
                alert(response.message);
            });
    }

    static buscaCep(cep) {
        jQuery("#formCepGroup span").show();
        axios.get("/utilidades/cep/" + cep)
            .then(function (response) {
                let dados = response.data.data;
                jQuery("#formPais").val("BR");
                Promise.all([Utilidades.loadEstados("BR"), Utilidades.loadCidades(dados.uf)])
                    .then(function () {
                        if (dados) {
                            jQuery("#formLogradouro").val(dados.logradouro);
                            jQuery("#formNumero").val(dados.numero);
                            jQuery("#formMunicipio").val(dados.ibge);
                            jQuery("#formEstado").val(dados.uf);
                            jQuery("#formBairro").val(dados.bairro);

                            jQuery("#formLogradouro").attr('readonly', true);
                            jQuery("#formMunicipio").attr('readonly', true);
                            jQuery("#formEstado").attr('readonly', true);
                            jQuery("#formBairro").attr('readonly', true);

                            jQuery("#formCepGroup span").hide();
                        }
                    });
            })
            .catch(function () {
                swal.fire({
                    title: 'Cep não encontrado',
                    icon: 'warning'
                });
            });

    }
}
